<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal-success m-3">
        <div class="position-icon m-0 row py-3">
          <div class="col-4 p-0 text-center">
            <i
              class="fa fa-times fa-4x"
              aria-hidden="true"
            />
          </div>
          <div class="col-8 p-0 py-3 text">
            <strong>{{ $t("modal.failed") }}</strong>
          </div>
        </div>
        <div class="position-text text-center pt-5 p-3">
          {{ textModal }}
        </div>
        <div class="position-button-success">
          <button
            type="button"
            class="btn btn-info btn-success"
            @click="closeModal"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalSuccess',

  props: {
    textModal: {
      type: String,
      default: ''
    }
  },

  methods: {
    closeModal () {
      this.$emit('closeModal', 'unsuccessful')
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  background-color: rgba(128, 128, 128, 0.527) !important;
  display: flex;
  opacity: 1 !important;
  justify-content: center;
  align-items: center;
}
.modal-success {
  background: white !important;
  box-shadow: 2px 2px 20px 1px;
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 280px;
  border-radius: 9.9px;
}
.position-icon {
  height: 100px;
  background-color: #d9534f;
  border-radius: 9.9px 9.9px 0 0;
  color: white;
}
.position-icon > .text {
  font-size: 20px;
}
.position-text {
  height: 100px;
}
.position-button-success {
  text-align: center;
  margin-top: 20px;
}
.btn-success {
  background-color: #d9534f !important;
  border: 0 !important;
  width: 109.2px;
  border-radius: 6.5px !important;
  font-size: 17.7px !important;
  box-shadow: 2px 3px 3px rgb(172, 172, 172);
}
.btn-success:hover {
  background-color: #d9534fa8 !important;
}
.content-success {
  padding-top: 19.7px;
  padding-bottom: 13.1px;
  margin-bottom: 19.8px;
  font-size: 19.7px;
  text-align: center;
}
.align-icons-success {
  margin-left: 180px;
}
.success-text {
  text-align: center;
}
</style>
